<template>
  <LoadingState
    :loading="props.loading"
    :on-cancel="props.onCancel"
  />

  <div class="min-h-full">
    <NavBar />
    <header>
      <slot name="header" />
    </header>
    <div
      class="container md:mt-6 lg:container-fluid px-2 md:px-0 md:pd-2 mx-auto grid grid-cols-1 md:grid-cols-12 gap-x-4 min-h-full"
    >
      <main class="col-span-1 md:col-span-7 lg:col-span-8 2xl:col-span-9">
        <slot name="main" />
      </main>
      <aside class="col-span-1 md:col-span-5 lg:col-span-4 2xl:col-span-3">
        <slot name="aside" />
      </aside>
    </div>
  </div>
</template>

<script setup>
import LoadingState from "@/components/shared/LoadingState.vue";
import NavBar from '@/components/navigation/NavBar.vue';

const props = defineProps({
  loading: {
    default: false,
    type: Boolean
  },
  onCancel: {
    default: () => {},
    type: Function
  }
})
</script>

<style scoped></style>
